import antdData from 'antd/locale/en_US'
import localeData from 'react-intl/locale-data/en'

import error from './error'
import form from './form'
import global from './global'
import license from './license'
import notification from './notification'
import settings from './settings'
import sustainability from './sustainability'
import widget from './widget'

export default {
  locale: 'en-US',
  antdData,
  localeData,
  messages: {
    ...global,
    ...form,
    ...settings,
    ...widget,
    ...sustainability,
    ...error,
    ...notification,
    ...license,
  },
}
